import React from "react";
import StrategySettingsForm from "./StrategySettingsForm";

const Strategy = () => {
  return (
    <div className="flex flex-row justify-start items-start gap-10">
      <StrategySettingsForm />
      <div className="flex flex-col justify-start items-start gap-5">
        
      </div>
    </div>
  );
};

export default Strategy;
